/* Forever Leeds — homepage interactions: reveal on scroll, count-up stats,
   mobile sticky shop bar, swatch selection. Lightweight, no dependencies. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- reveal on scroll + count-up ----- */
  function fmt(v, dec) {
    return dec ? v.toFixed(dec) : Math.floor(v).toLocaleString('en-GB');
  }
  function countUp(el) {
    if (el._d) return; el._d = 1;
    var target = parseFloat(el.dataset.count),
        suffix = el.dataset.suffix || '',
        dec = parseInt(el.dataset.decimals || '0', 10);
    if (RM || isNaN(target)) { el.textContent = fmt(target || 0, dec) + suffix; return; }
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / 1100, 1);
      el.textContent = fmt(p * target, dec) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function reveal(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    el.querySelectorAll('[data-count]').forEach(countUp);
    if (el.matches('[data-count]')) countUp(el);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    document.querySelectorAll('.fl-reveal, [data-count]').forEach(function (el) { io.observe(el); });
  }
  /* Safety sweep so nothing stays hidden if the observer is skipped (fast scroll / no IO) */
  function flSweep() {
    var h = window.innerHeight || 800;
    document.querySelectorAll('.fl-reveal:not(.is-in), [data-count]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < h * 1.05 && r.bottom > -40) reveal(el);
    });
  }
  flSweep();
  var flSweepT;
  window.addEventListener('scroll', function () { if (flSweepT) return; flSweepT = setTimeout(function () { flSweepT = null; flSweep(); }, 120); }, { passive: true });
  window.addEventListener('resize', flSweep, { passive: true });
  window.addEventListener('load', flSweep);

  /* ----- mobile sticky shop bar ----- */
  var ms = document.querySelector('.fl-msticky');
  if (ms) {
    window.addEventListener('scroll', function () {
      ms.classList.toggle('is-on', window.scrollY > 620);
    }, { passive: true });
  }

    /* ----- visual swatch selection on bespoke cards (toggle + image swap) ----- */
  function flSelectSwatch(sw) {
    var group = sw.parentElement;
    group.querySelectorAll('.fl-sw').forEach(function (o) { o.classList.remove('is-sel'); o.setAttribute('aria-pressed', 'false'); });
    sw.classList.add('is-sel'); sw.setAttribute('aria-pressed', 'true');
    var src = sw.getAttribute('data-img');
    if (!src) return;
    var card = sw.closest('.fl-pcard');
    var img = card && card.querySelector('.fl-pcard__img img');
    if (!img) return;
    img.src = src;
    var ss = sw.getAttribute('data-srcset');
    if (ss) { img.setAttribute('srcset', ss); } else { img.removeAttribute('srcset'); }
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.fl-sw');
    if (sw) flSelectSwatch(sw);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = e.target && e.target.closest ? e.target.closest('.fl-sw') : null;
    if (sw) { e.preventDefault(); flSelectSwatch(sw); }
  });
})();

/* FL-SELECT-PROMPT: PDP starts with no variant selected. Relabel the disabled ATC buttons
   (both the main button and the mobile sticky bar) to "Choose your size" on load
   (observer-free, no MutationObserver). Once the shopper picks an option Minimog completes
   the variant and restores its own "Add to cart" label. */
(function () {
  var root = document.querySelector('.template-product');
  if (!root) return;
  var PROMPT = 'Choose your size';
  function buttons() {
    var list = [];
    var main = root.querySelector('[name="add"]');
    if (main) list.push(main);
    // Sticky ATC may sit at the end of the section (or be repositioned) — grab it explicitly.
    var sticky = document.querySelector('.m-sticky-addtocart [name="add"]');
    if (sticky && sticky !== main) list.push(sticky);
    return list;
  }
  function chosen() {
    var gs = [].slice.call(root.querySelectorAll('variant-picker .m-product-option')).filter(function (g) {
      var n = g.querySelector('[data-option-name]');
      return n && (n.getAttribute('data-option-name') || '').trim();
    });
    if (!gs.length) return true;
    for (var i = 0; i < gs.length; i++) {
      var s = gs[i].querySelector('.option-label--selected');
      if (!s || !s.textContent.trim()) return false;
    }
    return true;
  }
  function sync() {
    try {
      var notChosen = !chosen();
      buttons().forEach(function (btn) {
        var txt = btn.querySelector('.m-add-to-cart--text');
        if (!txt) return;
        if (notChosen && btn.disabled) {
          if (txt.textContent.trim() !== PROMPT) txt.textContent = PROMPT;
          btn.classList.add('fl-cta-prompt');
        } else {
          btn.classList.remove('fl-cta-prompt');
        }
      });
    } catch (e) {}
  }
  sync();
  // Re-run shortly after load so we win over the sticky bar's own "Unavailable" label.
  setTimeout(sync, 300);
  setTimeout(sync, 900);
  root.addEventListener('change', function () { setTimeout(sync, 120); }, true);
})();

